import React from "react";
import styled from "styled-components";
import { localize } from "@backpacker/number";
import { Dot } from "@charty/legend/item";
import { FontWeight, Spacing } from "@glossy";
import { getMetricLabel } from "@linkfluence/i18n";
import { Locale } from "@linkfluence/models/locale";
import { Metric } from "@linkfluence/models/metric";

const Root = styled.div`
  display: flex;
  column-gap: ${Spacing.ExtraSmall};
  align-items: center;
`;

const Label = styled.span`
  font-weight: ${FontWeight.Normal};
`;

export const getTooltipTitle = (node) => (
  <Root>
    <Dot color={node.color} />
    <Label>{node.label}</Label>
  </Root>
);

export const getTooltipContent = (node, metric: Metric, locale: Locale) =>
  `${localize(locale, node.value)} ${getMetricLabel(locale, metric)}`;
